import { CUTTING_SHAPE_ID } from '@/domain/selection/reservedSelectionIds';
import { getFabricGroupById } from '@/infrastructure/engine2d/helpers/FabricGroupHelper';
import { Point, type BasicTransformEvent, FabricObject, IText, Canvas } from 'fabric';

// Custom prop set on the fabric object at creation for fields whose
// domain-side ImageField.behavior.constrainToFrameX is true. Reading a
// flag on the target keeps the callback O(1) and removes any need for
// FabricScene to maintain a parallel id list.
type TConstrainable = FabricObject & { constrainToFrameX?: boolean };

function objectMovingConstrainCallback(boundingBoxTest: { br: Point; tl: Point }) {
    const OFFSET = 3; // avoid overlapping the frame edge
    return (options: BasicTransformEvent & { target: FabricObject }) => {
        const target = options.target as TConstrainable;
        if (!target.constrainToFrameX) {
            return;
        }

        if (target.left < boundingBoxTest.tl.x) {
            target.set('left', boundingBoxTest.tl.x + OFFSET);
            target.set('top', boundingBoxTest.tl.y + OFFSET);
            target.set('dirty', true);
            target.setCoords();
            return;
        }
        if (target.left + target.width - OFFSET > boundingBoxTest.br.x) {
            target.set('left', boundingBoxTest.br.x - target.width);
            target.set('top', boundingBoxTest.br.y - target.height);
            target.set('dirty', true);
            target.setCoords();
            return;
        }
    };
}

function onFabricCanvasScaleCallback(object: { target: FabricObject }) {
    const target = object.target as IText;
    if (target?.text) {
        const scaledWidth = target.getScaledWidth();

        target.set({
            width: scaledWidth,
            scaleX: 1,
            scaleY: 1,
        });
    }
}

function setCuttingPathVisibility(fabricCanvas: Canvas, opacity: number) {
    const cuttingGroup = getFabricGroupById(fabricCanvas, CUTTING_SHAPE_ID);
    if (!cuttingGroup) {
        return;
    }
    // check if cutting group exist
    const isClipped = cuttingGroup?.getObjects().every((obj) => !obj.clipPath);
    if (!isClipped) {
        return;
    }
    cuttingGroup.opacity = opacity;
}

export { objectMovingConstrainCallback, onFabricCanvasScaleCallback, setCuttingPathVisibility };
